<script>
    import CopyToClipboard from '../util/CopyToClipboard.svelte';
    import { createEventDispatcher } from 'svelte';
    import { slide } from 'svelte/transition';
    export let result;
    export let decodingInProgress;

    const dispatch = createEventDispatcher();
    function build() {
        dispatch('build');
    }
</script>

<style>

.build-control {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
}

.build-control label {
	display: inline-block;
	font-weight: normal;
	letter-spacing: 0.05em;
	cursor: pointer;
    margin-bottom: 0;
}

.build-control button {
	margin-bottom: 0;
	cursor: pointer;
}

</style>

<div style="display: flex;" class:jittering={decodingInProgress} in:slide={{delay: 150}}>
    <div class="box lev1 light build-control" style="width: calc(25% + 3rem); padding-right: 3rem;">
        <button id="play"
            class="action-button red hovery"
            title="Play"
            class:processing={decodingInProgress}
            disabled={decodingInProgress}
            on:click={build}>&nbsp;</button>
        <label for="play">Play</label>
    </div>
    <div class="box red lev1" style="width: 75%; margin-left: -3rem;">
        <div class="box light light-border lev2" style="display: flex; justify-content: space-between;">
            {#if result}
                <div>{result}</div> {#if !decodingInProgress}<CopyToClipboard text={result}/>{/if}
            {:else}
                <div>&nbsp;</div>
            {/if}
        </div>
    </div>
</div>